import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import IComImageSlider from "@components/IComImageSlider/IComImageSlider";

@inject("store")
@observer
export default class DocTypeImages extends React.Component {

    // model props
    constructor(props) {
        super(props);

        //this.ref = Math.random().toString(36).substr(2, 9);
    }

    render() {
        if (!this.props.model.images) {
            return (null);
        }

        if (this.props.model.images.indexOf(",") > -1) {
            let imageObjects = [];
            this.props.model.images.split(",").map(url => {
                imageObjects.push({"src": url, "original": url});
            });
            return (<div className="doc-type-images">
                <IComImageSlider images={imageObjects} showThumbnails={false} showBullets={true} infinite={true} disableImageZoom={true}/>
                </div>);
        }

        return (<div className="doc-type-images"><img src={this.props.model.images} /></div>);

    }
}